import { AfterContentInit, Component, ElementRef } from '@angular/core';

import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

/**
 * Wraps a password input and adds an eye button that shows or hides its value.
 *
 * Lets users check what they typed or pasted, and gives those whose browser or security tooling
 * blocks pasting into password fields a plain text field to paste into instead.
 */
@Component({
    selector: 'app-password-toggle',
    templateUrl: './password-toggle.component.html',
    styleUrls: ['./password-toggle.component.scss'],
    standalone: false,
})
export class PasswordToggleComponent implements AfterContentInit {
    visible = false;
    private input?: HTMLInputElement;

    constructor(private host: ElementRef<HTMLElement>) {}

    ngAfterContentInit(): void {
        this.input = this.host.nativeElement.querySelector('input') ?? undefined;
    }

    get label(): string {
        return this.visible
            ? $localize`:@@passwordToggle.hide:Verberg wachtwoord`
            : $localize`:@@passwordToggle.show:Toon wachtwoord`;
    }

    toggle(): void {
        if (!this.input) {
            return;
        }
        this.visible = !this.visible;
        this.input.type = this.visible ? 'text' : 'password';
    }

    protected readonly faEye = faEye;
    protected readonly faEyeSlash = faEyeSlash;
}
